// extracted by mini-css-extract-plugin
export default {"feature-span":"W4VqrEk0PpxZJoQ1Z3VD","featureSpan":"W4VqrEk0PpxZJoQ1Z3VD","feature-text":"ng65qZmDFM1xLIblT4Ra","featureText":"ng65qZmDFM1xLIblT4Ra"};